export default {
  wechart: '微信',
  common: {
    copyright: '广州幂动科技有限公司版权所有',
  },
  route: {
    home: '首页',
    aso: 'ASO',
    ytoutiao: '悦头条',
    tbaoke: '淘宝客',
    contactus: '联系我们',
  },
  home: {
    head: {
      textLine1: '领先的移动互联网大数据营销平台',
      textLine2: '',
      subText: '全网资源矩阵覆盖 高效商业变现方案',
    },
    content1: {
      yTitle: '我们的优势',
      contentItem1: '媒体覆盖全面',
      contentItem2: '广告形式多样',
      contentItem3: '数据技术强大',
      contentItem4: '推荐算法精准',
    },
    content2: {
      contentItem1: {
        mainContent: 'IOS一站式推广解决方案',
        subContent: '提供包括上架/快审，选词筛词，ASO/ASM，数据追踪，评论优化，行业报告在内的ISO营销综合服务',
      },
      contentItem2: {
        mainContent: '信息流广告投放',
        subContent: '自有月活500万资讯类产品悦头条，支持开屏，横幅，信息流，激励视频，应用墙等多种广告投放形式，通过推荐算法为广告主匹配精准优质用户',
      },
      contentItem3: {
        mainContent: '淘宝客',
        subContent: 'App矩阵 + 微信群体系构建的淘宝客流量基础，通过特优惠App提供共享App模式，为渠道加盟商提供管理代理和用户的工具，汇聚流量为商户提供优质推广渠道，为用户提供各家电商平台优惠券',
      },
    },
    cooperator: '合作伙伴',
  },
  contactus: {
    headProp: {
      textLine1: '我们努力无畏，年轻活力',
      textLine2 : '让广告更聪明',
      subTexts : ['广州幂动科技有限公司是国内领先的移动营销整合服务商。通过深度的大数据聚合能力和高效的数据运营方式，结合自身特有的微信，APP立体化流量矩阵，为全球广告主提供一站式推广解决方案。幂动科技深入对接移动端全场景数据，通过媒体属性及用户标签对数据实行分层化管理，并运用精准投放技术，实现多维度定向投放。提供的服务包括效果广告、应用商店搜索优化，品牌广告等。服务客户包括腾讯，百度，阿里，京东，今日头条，咪咕等国内一线公司。',
      '幂动科技团队成员来自清华大学，中山大学等院校，有在腾讯，网易，搜狗等互联网一线公司工作经历。团队成员曾在KDD等国际顶会发表过论文，也曾在Topcoder等国际编程比赛中获得过全球第六的成绩。',
      ]
    },
    glory: {
      title: '幂动荣耀',
      imageGlory: 'https://ytoutiao.oss-cn-shenzhen.aliyuncs.com/contactus-glory.png'
    },
    contact: {
      title: '联系我们',
      subTitle: '7*24小时，不仅仅是商务的义务',
      contactItem1: 'IOS一站式推广解决方案',
      contactItem2: '悦头条',
      contactItem3: '悦头条',
    }
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh.js